module.exports = __webpack_public_path__ + "img/6-13_Keyfactor_2.4951fdd7.png";